function currencyFormat(num) {
    let currNumber = Number(num)
    if (currNumber) { return 'IDR ' + currNumber.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }
    else { return 0 }
}

function formatThousandSeparatorString(num) {
    // Pastikan input string, buang karakter kecuali digit dan koma
    const str = String(num).replace(/[^,\d]/g, '');
    // Pisah integer & decimal
    const [intPart, decPart] = str.split(',');
    // Sisipkan titik tiap 3 digit (dari kanan) di bagian integer
    const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  
    // Jika ada decimal, gabungkan kembali dengan koma
    return decPart !== undefined 
      ? `${formattedInt},${decPart}` 
      : formattedInt;
  }
  

function cleanNumber(num) {
    let number = num.replace(/\./g, '');

    number = number.replace(',', '.');

    return number;
}

export { currencyFormat, cleanNumber, formatThousandSeparatorString }